import {useTranslation} from 'hooks/translations/useCustomTranslation';

import {Typography} from '@mui/material';

import {Group} from 'lib/api/backend.schemas';
import {SubcomponentsFeaturesComponent} from 'lib/api/strapi';

import {Grid} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';

import styles from './GroupsInfoSection.module.scss';

const DoorsFeature = ({features, numberDoors}) => {
  const {t} = useTranslation('strapiComponents');

  if (features?.tueren || numberDoors) {
    return (
      <Grid xxs={12} xs={6} className={styles.gridItem}>
        <CustomIcon name="door" className={styles.icon} />
        <Typography className={styles.featureText}>
          {`${t('doors')} ${features?.tueren ? features?.tueren : numberDoors}`}
        </Typography>
      </Grid>
    );
  }
  return null;
};

const PersonsFeature = ({features, numberSeats}) => {
  const {t} = useTranslation('strapiComponents');

  if (features?.personen || numberSeats) {
    return (
      <Grid xxs={12} xs={6} className={styles.gridItem}>
        <CustomIcon name="people" className={styles.icon} />
        <Typography className={styles.featureText}>
          {`${t('persons')} ${features?.personen ? features?.personen : numberSeats}`}
        </Typography>
      </Grid>
    );
  }
  return null;
};

const PayloadFeature = ({features, cargoLoad}) => {
  const {t} = useTranslation('strapiComponents');

  if (features?.nutzlast || cargoLoad) {
    return (
      <Grid xxs={12} xs={6} className={styles.gridItem}>
        <CustomIcon name="weight" className={styles.icon} />
        <Typography className={styles.featureText}>
          {`${t('payload')} ${features?.nutzlast ? features?.nutzlast : cargoLoad}`}
        </Typography>
      </Grid>
    );
  }
  return null;
};

const DrivingLicenseFeature = ({features, licenseClass}) => {
  const {t} = useTranslation('strapiComponents');

  if (features?.fuererscheinklasse || licenseClass) {
    return (
      <Grid xxs={12} xs={6} className={styles.gridItem}>
        <CustomIcon name="drivingLicense" className={styles.icon} />
        <Typography className={styles.featureText}>
          {`${t('drivingLicenseClass')} ${
            features?.fuererscheinklasse ? features?.fuererscheinklasse : licenseClass
          }`}
        </Typography>
      </Grid>
    );
  }
  return null;
};

const AgeFeature = ({features, minAge}) => {
  const {t} = useTranslation(['strapiComponents', 'common']);

  if (features?.mindestalter || minAge) {
    return (
      <Grid xxs={12} xs={6} className={styles.gridItem}>
        <CustomIcon name="cake" className={styles.icon} />
        <Typography className={styles.featureText}>
          {`${t('minAge')} ${features?.mindestalter ? features?.mindestalter : minAge} ${t('years')}`}
        </Typography>
      </Grid>
    );
  }
  return null;
};

const DrivingExperienceFeature = ({features, drivingExperience}) => {
  const [t] = useTranslation(['strapiComponents', 'common']);

  if (features?.fahrpraxis || drivingExperience) {
    return (
      <Grid xxs={12} xs={6} className={styles.gridItem}>
        <CustomIcon name="drivingExperience" className={styles.icon} />
        <Typography className={styles.featureText}>
          {`${t('drivingExperience')} ${
            features?.fahrpraxis ? features?.fahrpraxis : drivingExperience
          } ${(features?.fahrpraxis ? features?.fahrpraxis : drivingExperience) > 1 ? t('years') : t('year')}`}
        </Typography>
      </Grid>
    );
  }
  return null;
};

export const FeatureContainer = ({
  features,
  groupData,
}: {
  features: SubcomponentsFeaturesComponent;
  groupData: Group;
}) => {
  console.log(features);
  return (
    <Grid container columnSpacing={'5%'} rowSpacing={'10px'}>
      <DoorsFeature features={features} numberDoors={groupData?.numberDoors} />
      <DrivingLicenseFeature features={features} licenseClass={groupData?.licenseClass} />
      <PersonsFeature features={features} numberSeats={groupData?.numberSeats} />
      <AgeFeature features={features} minAge={groupData?.minAge} />
      <PayloadFeature features={features} cargoLoad={groupData?.cargoLoad} />
      <DrivingExperienceFeature
        features={features}
        drivingExperience={groupData?.drivingExperience}
      />
    </Grid>
  );
};
